import { MonoStat, Tile, type StatusPipStatus } from '@diwata/ironvale'
import type { LogFeed } from '@/api/feeds'
import { UnavailableNote } from './shared'

/** The build log's honesty check — behind-by-N, from `trace log status`. */
export function LogTile({ feed }: { feed: LogFeed }) {
  const status: StatusPipStatus =
    feed.status === 'unavailable' ? 'unavailable' : feed.state === 'current' ? 'ok' : 'warn'
  return (
    <Tile title="Log" status={status} asOf={feed.asOf}>
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <>
          <div className="ap-stat-row">
            <MonoStat
              value={feed.behind_by ?? 0}
              label={feed.state === 'current' ? 'merges unlogged — current' : 'merges behind'}
            />
          </div>
          <p className="ap-tile-note">
            {feed.newest_id ? `newest entry ${feed.newest_id}` : 'no entries yet'}
          </p>
        </>
      )}
    </Tile>
  )
}
